import { render, staticRenderFns } from "./KeywordListDropdown.vue?vue&type=template&id=8d8e1182&scoped=true"
import script from "./KeywordListDropdown.vue?vue&type=script&lang=js"
export * from "./KeywordListDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8e1182",
  null
  
)

export default component.exports